<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"><router-link class="decoration" to="/"> {{language[1]['Home']}} </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>Default Message</h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div style="padding-bottom: 50px;" class="container-fluid">
                <div class="card bdr-rad2 mt-1 shadow p-2 ">
                <div class="card-body">


                    <form @submit.prevent="SaveUrl()" >

<b-modal :id="infoModal3.id" 
  
  size="sm" 
  > 
  <template #modal-title>
                  <h5>New User Type</h5>
                </template>
  <div>
    <input  v-model="all_data.newroles"   style="font-size: small;" class="form-control" >
  </div>
  <template #modal-footer>
                  <button style="font-size: small;"  @click="saveRoleType" class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad">Save</button>
                  
                </template>
 </b-modal>

 


<div class="row">
 
  
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">{{language[16]['Main Category']}} </label>
            <v-select @input="subCat"  v-model="all_data.maincat" :options="mainscats"  label="category_name" ></v-select>
    </div>
  </div>
 
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">{{language[17]['Sub Category']}}</label>
            <v-select @input="laodMessage()"  v-model="all_data.subcat" :options="subcats"  label="category_name" :disabled="!all_data.maincat"></v-select>
    </div>
  </div>
  
 
 

  
</div>


<div class="row">

    <div class="col-md-6">
    <div class="form-group ">
           
           
            <textarea rows="15"  v-model="message.body" style="font-size: small;" class="form-control" > </textarea>
    </div>
  </div>

</div>























   

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">{{language[78]['Update']}}</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
           
            </div>
          </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import httpClient from '@/axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
            this.loadCat()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            language:JSON.parse(authService.isLanguage()),
            id:this.$route.query.id,
        total:0,
        selectedOption: null, // Store the selected option
        selectusertype:true,
        newusertype:false,
        mainscats:[],
        subcats:[],
        message:{},
        all_data:{
          'newuser':false,
        },
       
        infoModal3: {
          id: 'info-modal3',
          title: '',
          content: [],
        },
      
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {


            async subCat() {
    // console.log("aaaaa");
    // console.log(this.issue.maincat);
    if(this.all_data.maincat == null){
        this.all_data.subcat = '';
    } 
    try {
      const { data} = await  httpClient.post('/web/api/issuetracking/loadsub',{userid:this.userid,issue:this.all_data},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       
       this.subcats = data.subcats;
       
      
    } catch (error) {
      console.log(error.response);
    }
  },


  async laodMessage() {
    // console.log("aaaaa");
    // console.log(this.issue.maincat);
    if(this.all_data.maincat == null){
        this.all_data.subcat = '';
    } 
    try {
      const { data} = await  httpClient.post('/web/api/issuetracking/loadmessage',{userid:this.userid,all_data:this.all_data},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.message = data.message;
       
       
       
      
    } catch (error) {
      console.log(error.response);
    }
  },


   

  


    async loadCat() {
    
    console.log(this.issue);
   
    try {
      const { data} = await  httpClient.get('/web/api/issuetracking/loadcat',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.mainscats = data.mainscats;
       
      
    } catch (error) {
      console.log(error.response);
    }
  },

    async SaveUrl() {
    
   
    console.log("amilaaaa");
       try {
         const { data} = await  httpClient.post('/web/api/issuetracking/updatemessage',{userid:this.userid,all_data:this.all_data,message:this.message},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          window.location.reload();
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
     },
       

     

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    